import consulta from '@cannect/assets/img/home/journey/consulta.webp'
import paciente from '@cannect/assets/img/home/journey/paciente.webp'
import produto from '@cannect/assets/img/home/journey/produto.webp'

/**
 * As três entradas de jornada (Figma node 4431:470).
 *
 * O mesmo trio aparece no hero e em "Qual é o próximo passo", então a lista vive junto do
 * componente. Os destinos são os mesmos que os CTAs do hero passaram a usar: `/conta` é rota
 * autenticada, então já cai no login quando não há sessão.
 *
 * O aviso "Nem todas as compras exigem consulta" era um disclaimer solto no rodapé do hero e a
 * revisão o absorveu na descrição do primeiro card.
 */
export const JOURNEY_CARDS = [
  {
    title: 'Quero fazer uma consulta',
    description: 'Nem todas as compras exigem consulta.',
    ctaLabel: 'Fazer uma consulta',
    path: '/agendamento',
    image: consulta
  },
  {
    title: 'Quero encontrar um produto',
    description: 'Sei o que quero ou tenho uma receita.',
    ctaLabel: 'Buscar produtos',
    path: '/produtos',
    image: produto
  },
  {
    title: 'Já sou paciente Cannect',
    description: 'Acompanhar, renovar ou recomprar.',
    ctaLabel: 'Acessar minha jornada',
    path: '/conta?pagina=pedidos-todos',
    image: paciente
  }
]
